export default __webpack_public_path__ + "static/media/1728.0ebd73a0.png";